import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';


function parseProvider(provider) {
  if (isFunction(provider)) {
    return { Element: provider, props: {} };
  }

  if (isObject(provider) && 'element' in provider && 'props' in provider) {
    return { Element: provider.element, props: provider.props };
  }

  throw new Error('Improperly configured.');
}

function Composer({ children, providers = [] }) {
  return (
    <>
      {providers.reduceRight((hierarchy, provider) => {
        const { Element, props: elementProps } = parseProvider(provider);
        return <Element {...elementProps}>{hierarchy}</Element>;
      }, children)}
    </>
  );
}

Composer.displayName = 'Composer';
export default Composer;
